import { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { useDepots, fmtDepot } from "@/lib/depots";
import { Wrench, Warning, CheckCircle, Clock } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Maintenance() {
  const depotMap = useDepots();
  const [buses, setBuses] = useState([]);
  useEffect(()=>{ api.get("/fleet/buses").then(({data})=>setBuses(data)); }, []);

  const today = new Date();
  const status = useMemo(()=>{
    const due = [], overdue = [], soon = [];
    buses.forEach(b => {
      const d = new Date(b.service_due);
      const diff = Math.round((d - today)/(1000*60*60*24));
      if (diff < 0) overdue.push({...b, _days: diff});
      else if (diff <= 7) due.push({...b, _days: diff});
      else if (diff <= 30) soon.push({...b, _days: diff});
    });
    return { due, overdue, soon };
  }, [buses]);

  const sendToService = async (id) => {
    await api.patch(`/fleet/buses/${id}/status`, { status: "Maintenance" });
    setBuses(p => p.map(b => b.id === id ? { ...b, status: "Maintenance" } : b));
    toast.success("Scheduled to maintenance");
  };

  return (
    <div className="p-4 lg:p-6 space-y-5 lg:space-y-6">
      <div>
        <div className="label-cap text-slate-500">Workshop</div>
        <h1 className="font-display text-2xl lg:text-3xl font-bold leading-tight">Maintenance Intelligence</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          { l: "In Workshop", v: buses.filter(b=>b.status==="Maintenance").length, c:"#F97316", i: Wrench },
          { l: "Overdue Service", v: status.overdue.length, c:"#EF4444", i: Warning },
          { l: "Due in 7 days", v: status.due.length, c:"#F97316", i: Clock },
          { l: "Due in 30 days", v: status.soon.length, c:"#1E3A8A", i: CheckCircle },
        ].map(x=>(
          <div key={x.l} className="ktcl-card ktcl-card-hover p-4">
            <div className="flex items-center justify-between">
              <div className="label-cap text-slate-500">{x.l}</div>
              <x.i size={18} weight="duotone" style={{color:x.c}}/>
            </div>
            <div className="font-display text-2xl font-bold mt-2" style={{color:x.c}}>{x.v}</div>
          </div>
        ))}
      </div>
      <div className="ktcl-card overflow-x-auto scroll-thin">
        <div className="p-4 border-b border-slate-200">
          <div className="label-cap text-slate-500">Service Schedule</div>
          <h3 className="font-display font-bold text-lg">All buses requiring attention</h3>
        </div>
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-slate-50"><tr className="text-left text-xs text-slate-500">
            {"Fleet ID,Registration,Depot,Odometer,Battery,Service Due,Status,Action".split(",").map(h=><th key={h} className="px-3 py-2 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {[...status.overdue, ...status.due, ...status.soon].map(b=>(
              <tr key={b.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-3 py-2 font-mono font-bold text-[#1E3A8A]">{b.fleet_id}</td>
                <td className="px-3 py-2 font-mono text-xs">{b.registration_number}</td>
                <td className="px-3 py-2">{fmtDepot(b.depot, depotMap)}</td>
                <td className="px-3 py-2 text-right tabular-nums">{b.odometer.toLocaleString("en-IN")} km</td>
                <td className="px-3 py-2 tabular-nums">{b.battery_health}%</td>
                <td className="px-3 py-2 text-xs">
                  <span className={b._days < 0 ? "text-[#EF4444] font-semibold" : b._days < 7 ? "text-[#F97316] font-semibold" : "text-slate-600"}>
                    {b.service_due} ({b._days < 0 ? `${Math.abs(b._days)}d overdue` : `in ${b._days}d`})
                  </span>
                </td>
                <td className="px-3 py-2"><span className="text-xs px-2 py-0.5 bg-slate-100 rounded">{b.status}</span></td>
                <td className="px-3 py-2 text-right">
                  <button onClick={()=>sendToService(b.id)} className="text-xs px-2 py-1 border border-slate-200 rounded hover:bg-slate-100">Schedule Service</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
